export default __webpack_public_path__ + "./images/mp.06bc7835.png";